<ul class="nav nav-tabs nav-fill">
  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{ active: isTabActive(FilterTab.Filters) }"
      (click)="switchTab(FilterTab.Filters)"
      href="javascript:void(0)"
    >
      {{ "filters.tabs.all-filters" | translate }}
    </a>
  </li>

  <li class="nav-item">
    <a
      class="nav-link"
      [ngClass]="{
        active: isTabActive(FilterTab.ActiveFilters),
        disabled: isTabDisabled(FilterTab.ActiveFilters),
      }"
      (click)="switchTab(FilterTab.ActiveFilters)"
      href="javascript:void(0)"
    >
      {{ "filters.tabs.active-filters" | translate }}
      @if (hasActiveFilters) {
        <span>
          {{ activeFiltersCount }}
        </span>
      }
    </a>
  </li>
</ul>

<!--  Selected Tab Content -->
@switch (currentTab) {
  <!-- ✅ All Filters Tab -->
  @case (FilterTab.Filters) {
    <div class="sidebar-form">
      <app-search-input
        [placeholder]="'filters-sidebar.search.placeholder' | translate"
        (inputChanged)="onSearchFilterChange($event)"
      >
      </app-search-input>
    </div>
    <div class="filters-pane">
      <div class="filters-list">
        @if (filteredFilters$ | async; as filtered) {
          @for (filter of filtered; track filter.property_uri_facet) {
            <div class="filter">
              <div class="filter-title" (click)="toggleFilter(filter)">
                <div class="title">
                  <div
                    [innerHTML]="filter.name | highlight: searchFilter"
                  ></div>
                  @if (filter.loading) {
                    <div class="loading">
                      <app-loading [size]="'sm'"></app-loading>
                    </div>
                  }
                </div>
                <div>
                  <fa-icon
                    [icon]="
                      filter.expanded
                        ? ['fas', 'chevron-down']
                        : ['fas', 'chevron-right']
                    "
                  ></fa-icon>
                </div>
              </div>
              @if (filter.expanded) {
                <div
                  class="filter-items"
                  [ngClass]="{ disabled: filter.loading }"
                >
                  @if (
                    filter.expanded &&
                    filter.items.length == 0 &&
                    filter.offset > -1
                  ) {
                    <div class="no-filter-items">
                      {{
                        "feed.filters.there-are-no-values-to-display"
                          | translate
                      }}
                    </div>
                  }
                  @for (item of filter.items; track item) {
                    <div
                      class="filter-item"
                      [ngClass]="{
                        include: item.checked && item.type === 'include',
                        exclude: item.checked && item.type === 'exclude',
                      }"
                    >
                      <div class="filter-item-title">
                        <span class="title">{{ item.title }}</span>
                        <span class="count">{{
                          item.count_posts | number
                        }}</span>
                      </div>
                      <div class="filter-item-tools">
                        <sui-toggle
                          variant="filter"
                          [ngModel]="getItemCheckType(item)"
                          [ngModelOptions]="{ standalone: true }"
                          (ngModelChange)="
                            handleAllFiltersSliderChange($event, filter, item)
                          "
                        ></sui-toggle>
                      </div>
                    </div>
                  }
                </div>
              }
              @if (filter.expanded && filter.has_more) {
                <div class="show-more">
                  @if (!filter.loading) {
                    <a (click)="showMore(filter)">
                      {{ "filters.link.show-more" | translate }}
                    </a>
                  }
                  @if (filter.loading) {
                    <span>
                      <fa-icon
                        [icon]="faSpinner"
                        animation="spin-pulse"
                      ></fa-icon>
                    </span>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </div>
  }
  <!-- ✅ Active Filters Tab -->
  @case (FilterTab.ActiveFilters) {
    <div class="filters-pane">
      <div class="filters-list">
        <div class="selected-filters">
          <sui-accordion
            [multiple]="true"
            [value]="activeFilterOpenKeys"
            (valueChange)="activeFilterOpenKeys = $event"
          >
            <!-- group = one filter_title / one property_uri -->
            @for (group of activeFilterGroups$ | async; track group) {
              <sui-accordion-item [value]="group.key">
                <span sui-accordion-header>
                  {{ group.title }}
                  <span>
                    {{ group.items.length }}
                  </span>
                </span>
                @for (item of group.items; track item) {
                  <div
                    class="filter-item"
                    [ngClass]="{
                      include: item.checked && item.type === 'include',
                      exclude: item.checked && item.type === 'exclude',
                    }"
                  >
                    <div class="filter-item-title">
                      <span class="title">
                        <!-- Different visualization per kind -->
                        @switch (item.kind) {
                          <!-- PERIOD FILTER -->
                          @case ("period") {
                            {{ getPeriodItemTitle(item) }}
                          }
                          <!-- VALUE FILTER, and fallback when kind is unset -->
                          @default {
                            {{ item.title || item.filter_title }}
                          }
                        }
                      </span>
                    </div>
                    <div class="filter-item-tools">
                      <sui-toggle
                        variant="filter"
                        [ngModel]="getItemCheckType(item)"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="
                          handleActiveFiltersSliderChange($event, item)
                        "
                      ></sui-toggle>
                    </div>
                  </div>
                }
              </sui-accordion-item>
            }
          </sui-accordion>
        </div>
        @if (hasActiveFilters) {
          <div class="create-dimensions-section">
            <div class="dimension-buttons">
              <sui-button
                variant="primary"
                [leadingIcon]="['fas', 'layer-group']"
                (click)="saveAsDimension()"
              >
                {{ "filters.button.save-as-dimension" | translate }}
              </sui-button>
              <sui-button
                variant="primary"
                [leadingIcon]="['fas', 'link']"
                (click)="attachAndSaveAsDimension()"
              >
                {{ "filters.button.save-and-link-to-feed" | translate }}
              </sui-button>
            </div>
          </div>
        }
      </div>
    </div>
  }
}
